<template>
  <div class="mt-10">
    <v-expansion-panels flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <p class="primary--text text-h6">Tipos de empleado</p>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <kn-employee-types />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
export default {
  components: {
    KnEmployeeTypes: () => import('@/components/configuration/KnEmployeeTypes.vue')
  }
}
</script>

<style>

</style>